/**
 * A list of HTML Element tag names which cannot natively receive focus without the addition of a
 * `tabindex` attribute.
 */

const nativelyFocusableElements = [
    HTMLInputElement,
    HTMLSelectElement,
    HTMLTextAreaElement,
    HTMLAnchorElement,
    HTMLButtonElement,
    HTMLAreaElement,
];

const isNativelyFocusableElement = (htmlElement: HTMLElement): boolean => {
    return Boolean(nativelyFocusableElements.find(ElementConstructor => htmlElement instanceof ElementConstructor));
};

export default isNativelyFocusableElement;
